<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <ng-container *ngIf="currency === 'RMB'; else fxTemplate">
    <nz-card>
      <span class="Risklabel">{{ "InvoiceInfo" | translate }}</span>
      <div nz-row nzGutter="50" style="margin-bottom: 10px;">
        <div nz-col>
          <button nz-button nzType="primary" class="default-button" (click)="addRow()"><span nz-icon nzType="plus"
              nzTheme="outline"></span>
            {{'Add'|translate}}</button>
        </div>
        <div nz-col *ngIf="currency === 'RMB'">
          <button  nz-button nzType="primary" class="default-button" (click)="exportTableToExecl()"><span nz-icon
              nzType="download" nzTheme="outline"></span>
            {{'DownloadExcel'|translate}}</button>
        </div>
        <div nz-col *ngIf="currency === 'RMB'">
          <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
            <button  nz-button class="upload-button default-button">
              <span nz-icon nzType="upload" nzTheme="outline"></span>
              {{'UploadExcel'|translate}}
            </button>
          </nz-upload>
        </div>
        <div nz-col>
          <button class="default-button" nz-button (click)="Submit()"
            [disabled]="InvoiceSerialNumberIsNull || SerialNumberInInvoice || foreignAmountsIncomplete" nzType="primary"><span nz-icon
              nzType="send" nzTheme="outline"></span>
            {{'Submit'|translate}}</button>
        </div>
        <div nz-col>
          <button class="default-button" nz-button (click)="SaveData()" nzType="primary"><span nz-icon nzType="save"
              nzTheme="outline"></span>
            {{'Save'|translate}}</button>
        </div>
        <div nz-col>
          <button nz-button nzType="primary" class="default-button" (click)="Retrun()"><span nz-icon nzType="arrow-left"
              nzTheme="outline"></span>
            {{'Return'|translate}}</button>
        </div>
      </div>
      <ng-container *ngIf="aliases.controls.length > 0">
        <form nz-form [formGroup]="validateForm">
          <nz-table [nzShowPagination]="false" nzSize="middle" #editRowTable nzBordered [nzData]="aliases.controls"
            [nzScroll]="{ y: '240px' }">
            <thead>
              <tr>
                <th scope="col" nzWidth="80px" style="text-align: center;">{{ "InvoiceSerialNumber" | translate}}</th>
                <th scope="col" nzWidth="150px" style="text-align: center;">
                  <span style="color: #ff4d4f;">* </span>{{ "InvoiceDate" | translate}}
                  <div style="margin-top: 5px;">
                    <button *ngIf="currency === 'RMB'" class="default-button" nz-button (click)="AsFirst('InvoiceDate')" nzType="primary"><span
                        nz-icon nzType="vertical-align-bottom" nzTheme="outline"></span>{{'AsFirst'|translate}}</button>
                  </div>
                </th>
                <th *ngIf="currency === 'RMB'" scope="col" nzWidth="150px" style="text-align: center;">
                  {{ "InvoiceCode" | translate}}
                  <div style="margin-top: 5px;">
                    <button class="default-button" nz-button (click)="AsFirst('InvoiceCode')" nzType="primary"><span
                        nz-icon nzType="vertical-align-bottom" nzTheme="outline"></span>{{'AsFirst'|translate}}</button>
                  </div>
                </th>
                <th scope="col" nzWidth="150px" style="text-align: center;">
                  <span style="color: #ff4d4f;">* </span>{{ "InvoiceNo" | translate}}
                </th>
                <th scope="col" nzWidth="100px" style="text-align: center;">
                  <span style="color: #ff4d4f;">* </span>{{ "InvoiceAmountBeforeTax" | translate}}
                </th>
                <th scope="col" nzWidth="100px" style="text-align: center;">
                  <span style="color: #ff4d4f;">* </span>{{ "Taxes" | translate}}
                </th>

                <!-- 【【【 核心修改點 1 】】】 -->
                <ng-container *ngIf="currency !== 'RMB'">
                  <th scope="col" nzWidth="200px" style="text-align: center;">
                    <span style="color: #ff4d4f;">* </span>{{ "TotalPriceIncludingTax" | translate}}
                  </th>
                </ng-container>

                <!-- 【【【 核心修改點 2 】】】 -->
                <th *ngIf="currency !== 'RMB'" scope="col" nzWidth="150px" style="text-align: center;">
                  <span style="color: #ff4d4f;">* </span>{{ "AutomatedInvoiceRecognition" | translate}}
                </th>

                <th scope="col" nzWidth="60px" style="text-align: center;">{{ "act" | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container formArrayName="aliases">
                <tr [formGroupName]="i" *ngFor="let control of aliases.controls; let i=index" class="editable-row">

                  <!-- InvoiceSerialNumber (需求 4：永遠禁用) -->
                  <td>
                    <input type="text" nz-input formControlName="InvoiceSerialNumber" />
                  </td>

                  <!-- InvoiceDate -->
                  <td>
                    <div class="compare-container">
                      <nz-date-picker formControlName="InvoiceDate" [nzFormat]="dateFormat"
                        style="width: 100%;"></nz-date-picker>
                      <div *ngIf="shouldShowComparison(control, 'InvoiceDate')" class="compare-text">
                        {{ 'AutomatedInvoiceRecognition' | translate }}:
                        {{ getComparisonDisplay(control, 'InvoiceDate') }}
                      </div>
                    </div>
                  </td>

                  <!-- InvoiceCode (RMB only) -->
                  <td *ngIf="currency === 'RMB'">
                    <input type="text" oninput="value=value.match(/^[0-9]*$/)" nz-input formControlName="InvoiceCode" />
                  </td>

                  <!-- InvoiceNo -->
                  <td>
                    <div class="compare-container">
                      <input type="text" [attr.oninput]="currency === 'RMB' ? 'value=value.match(/^[0-9]*$/)' : null"
                        nz-input formControlName="InvoiceNo" />
                      <div *ngIf="shouldShowComparison(control, 'InvoiceNo')" class="compare-text">
                        {{ 'AutomatedInvoiceRecognition' | translate }}:
                        {{ getComparisonDisplay(control, 'InvoiceNo') }}
                      </div>
                    </div>
                  </td>

                  <!-- InvoiceAmountBeforeTax -->
                  <td>
                    <input type="text" oninput="value=value.match(/^[0-9]+(?:\.\d{0,2})?/)" nz-input
                      formControlName="InvoiceAmountBeforeTax" (input)="calculateSum(i)"
                      (blur)="validateAndConfirm(i)" />
                  </td>

                  <!-- Taxes -->
                  <td>
                    <input type="text" oninput="value=value.match(/^[0-9]+(?:\.\d{0,2})?/)" nz-input
                      formControlName="Taxes" (input)="calculateSum(i)" (blur)="validateAndConfirm(i)" />
                  </td>

                  <!-- TotalPriceIncludingTax (Non-RMB) -->
                  <ng-container *ngIf="currency !== 'RMB'">
                    <td>
                      <div class="compare-container">
                        <input type="text" nz-input formControlName="TotalAmount" />
                        <div *ngIf="shouldShowComparison(control, 'TotalAmount')" class="compare-text">
                          {{ 'AutomatedInvoiceRecognition' | translate }}:
                          {{ getComparisonDisplay(control, 'TotalAmount') }}
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- AutomatedInvoiceRecognition (Non-RMB) -->
                  <td *ngIf="currency !== 'RMB'" style="text-align:center; vertical-align: middle;">
                    <!-- 狀態一：初始狀態 -->
                    <div *ngIf="control.get('editMode').value === 'initial'">
                      <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                        <button nz-button nzType="default" nz-tooltip
                          [nzTooltipTitle]="'UploadForeignInvoicePrompt' | translate">
                          <span nz-icon nzType="scan" nzTheme="outline"></span>
                          {{ 'AutomatedInvoiceRecognition' | translate }}
                        </button>
                      </nz-upload>
                    </div>

                    <!-- 狀態二：識別成功 -->
                    <div *ngIf="control.get('editMode').value === 'recognized'">
                      <div
                        style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"
                            style="font-size: 16px;"></span>
                          <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                            <button nz-button nzType="text" nzShape="circle" nz-tooltip
                              [nzTooltipTitle]="'ReRecognize' | translate">
                              <span nz-icon nzType="reload" nzTheme="outline"></span>
                            </button>
                          </nz-upload>
                        </div>
                        <div style="font-size: 12px; color: #888; margin-top: 4px;">
                          <a (click)="enableManualEdit(i)">{{ 'TooltipEditRecognition' | translate }}</a>
                        </div>
                      </div>
                    </div>

                    <!-- 狀態三：手動編輯模式 -->
                    <div *ngIf="control.get('editMode').value === 'editing'">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <button nz-button nzType="text" nzShape="circle" (click)="toggleLock(i)" nz-tooltip
                          [nzTooltipTitle]="control.get('isLocked')?.value ? 'Unlock' : 'Lock'">
                          <span nz-icon [nzType]="control.get('isLocked')?.value ? 'lock' : 'unlock'" nzTheme="outline"></span>
                        </button>
                        <!-- 還原按鈕 (需求 3：更換圖示) -->
                        <button *ngIf="control.get('recognizedData').value" nz-button nzType="text" nzShape="circle"
                          (click)="restoreRecognizedData(i)" nz-tooltip [nzTooltipTitle]="'TooltipRestore' | translate">
                          <span nz-icon nzType="rollback" nzTheme="outline"></span>
                        </button>
                        <!-- 重新識別按鈕 -->
                        <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                          <button nz-button nzType="text" nzShape="circle" nz-tooltip
                            [nzTooltipTitle]="'ReRecognize' | translate">
                            <span nz-icon nzType="reload" nzTheme="outline"></span>
                          </button>
                        </nz-upload>
                      </div>
                    </div>
                  </td>

                  <!-- 刪除按鈕 -->
                  <td style="text-align:center; vertical-align: middle;">
                    <button nz-button nz-tooltip nzTooltipTitle="{{'DeleteRow' | translate}}" nzType="text"
                      nzShape="circle" nzDanger (click)="deleteRow(i)">
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </nz-table>
        </form>
      </ng-container>

    </nz-card>
    </ng-container>
    <ng-template #fxTemplate>
      <app-edit-wmsm-StatementMaintain-fx
        [RNO]="RNO"
        [vendorCode]="vendorCode"
        [companyERP]="companyERP"
        [currency]="currency"
        [receiptDetails]="listOfGoodsData"
        (serialNumbersChange)="onFxSerialsChange($event)"
        (checkInvoiceItemRequest)="CheckInvoiceItem()"
        (returnRequest)="Retrun()">
      </app-edit-wmsm-StatementMaintain-fx>
    </ng-template>

    <!-- 將收貨清單移到通用區塊，RMB/非RMB皆顯示 -->
    <nz-card style="margin-top: 20px;">
      <div>
        <span class="Risklabel">{{ "ReceiptList" | translate }}</span>
        <nz-table #colSpanTable [nzData]="listOfGoodsData" style="margin-bottom: 10px" nzSize="middle"
          [nzFrontPagination]="false" [nzShowPagination]='false' [nzScroll]="{ y: '400px',x:'3000px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="100px">
                {{ "InvoiceSerialNumber" | translate}}
                <div style="margin-top: 5px;">
                  <button class="default-button" nz-button (click)="AsFirst('invoiceItem')" nzType="primary"><span
                      nz-icon nzType="vertical-align-bottom" nzTheme="outline"></span>{{'AsFirst'|translate}}</button>
                </div>
              </th>
              <th scope="col" nzWidth="100px">{{ "Company" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "table.PONO" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.POLN" | translate}}</th>
              <th scope="col" nzWidth="250px" style="text-align: center;">{{ "Spec" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.Price" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "table.RTNo" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "table.RTDate" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.RTLine" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "RTQTY" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.Currency" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "RTAmount" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.TaxRate" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "ReductionAmount" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "FinalInvoiceAmount" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "PlantCode" | translate}}</th>
              <th scope="col" nzWidth="250px" style="text-align: center;">{{ "Remark" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of listOfGoodsData;let i=index">
              <td>
                <nz-select [(ngModel)]="listOfInvoiceItemData[i]" name="invoiceItemSelect"
                  style="width: 100px" (ngModelChange)="GoodsinvoiceItemValueChange($event,i)" nzShowSearch
                  nzAllowClear>
                  <nz-option *ngFor="let option of InvoiceInfoSerialNumberList" [nzLabel]="option"
                    [nzValue]="option"></nz-option>
                </nz-select>
              </td>
              <td>{{data.companyCode}}</td>
              <td>{{data.pono}}</td>
              <td>{{data.poln}}</td>
              <td>{{data.spec}}</td>
              <td>{{data.finalPrice}}</td>
              <td>{{data.rtno}}</td>
              <td>{{data.rtDate}}</td>
              <td>{{data.rtln}}</td>
              <td>{{data.rtQty}}</td>
              <td>{{data.currency}}</td>
              <td>{{data.rtAmount}}</td>
              <td>{{data.taxRate}}</td>
              <td>{{data.decreaseMoney}}</td>
              <td>{{data.invoiceAmount}}</td>
              <td>{{data.plantCode}}</td>
              <td>{{data.remark}}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-card>
  </div>
</nz-spin>
